<template>
  <a-layout-header class="global-header" style="width: 100%; height: 48px; padding: 0">
    <div class="header-inner">
      <!-- Left: Logo -->
      <div class="header-left">
        <div class="logo-area" @click="toWorkplace">
          <div class="logo-icon">C</div>
          <span class="logo-text">CTC</span>
        </div>
      </div>

      <div class="header-spacer"></div>

      <!-- Right: Actions -->
      <div class="header-right">
        <!-- Factory slot (permission-gated) -->
        <div
          v-show="
            (!hasPermR([
              PermRoleKey.Fqc,
              PermRoleKey.Iqc,
              PermRoleKey.Oqc,
              PermRoleKey.Ipqc,
              PermRoleKey.Pt,
              PermRoleKey.Supply,
              PermRoleKey.SupplyMgr,
            ]) ||
              hasPermR(PermRoleKey.Admin)) &&
            !userStore.isOdUser()
          "
          class="header-right-item"
        >
          <slot name="factory"></slot>
        </div>

        <!-- Notification -->
        <global-header-message-notification class="header-right-item" />

        <!-- Help link -->
        <a
          class="header-right-item header-action"
          href="https://makeblock.feishu.cn/drive/folder/HjUufGq4elCxjJdBf9jcDViOnQf?from=from_copylink"
          target="_blank"
        >
          <question-circle-outlined />
          <span>{{ t('header.user_manual.title') }}</span>
        </a>

        <!-- Avatar (includes language switcher + user dropdown) -->
        <global-header-avatar />
      </div>
    </div>
  </a-layout-header>
</template>

<script setup lang="ts">
import { useUserStore } from '@/store';
import { PermRoleKey } from '@/types/permission';
import { hasPermR } from '@/utils/permission';
import { QuestionCircleOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import GlobalHeaderAvatar from './global-header-avatar.vue';
import GlobalHeaderMessageNotification from './global-message-notification.vue';

const { t } = useI18n();
const userStore = useUserStore();

interface Props {
  showFactorySwitch?: boolean; // 是否显示工厂切换器
}

defineProps<Props>();

/**
 * @description 前往工作台
 */
const router = useRouter();
function toWorkplace() {
  router.push({ name: 'workplace' });
}
</script>

<style scoped>
:deep(.ant-layout-header) {
  height: 48px;
  line-height: 48px;
}

.global-header {
  background: #1d2129 !important;
}

.header-inner {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 16px;
}

.header-left {
  display: flex;
  align-items: center;
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  padding-right: 20px;
  margin-right: 8px;
}

.logo-area {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.logo-icon {
  width: 26px;
  height: 26px;
  background: #3370ff;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
}

.logo-text {
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}

.header-spacer {
  flex: 1;
}

.header-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-right-item {
  display: flex;
  align-items: center;
}

.header-action {
  color: #86909c;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  white-space: nowrap;
}

.header-action:hover {
  color: #fff;
}
</style>
